export default function Logo(){
    return(
        <img style={{margin: 'auto', marginTop: '20px', maxWidth: '160px'}} width={'20%'} height={'auto'} alt="logo" src="./assets/logo.png"/>
    );
}